import { Injectable } from '@angular/core';

export interface LoginCredentials {
    login: string;
    ceName: string;
    storeCredentials: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class CredentialStoreService {

    private static readonly credentialKey: string = 'credentials';

    constructor() {
    }

    get credentials(): LoginCredentials {
        const jsonCredentials = localStorage.getItem(CredentialStoreService.credentialKey);
        const credentials = JSON.parse(jsonCredentials);
        if (!!credentials) {
            credentials.storeCredentials = true;
        }

        return credentials;
    }

    set credentials(credentials: LoginCredentials) {
        if (credentials.storeCredentials) {
            localStorage.setItem(CredentialStoreService.credentialKey, JSON.stringify({
                login: credentials.login,
                ceName: credentials.ceName
            }));
        } else {
            localStorage.removeItem(CredentialStoreService.credentialKey);
        }
    }
}
